import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const BucketWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  height: 214px;
  margin-right: 10px;
`;

const BucketLabel = styled.div`
  color: #a7a7a7;
  font-size: 20px;
  font-weight: 700;
`;

const BarColors = [
  '#ec2627',
  '#ee3536',
  '#ef4546',
  '#f05556',
  '#f26465',
  '#f37475',
  '#f48484',
  '#b8b8b8',
  '#b8b8b8',
  '#34e29a',
  '#1fd68a',
];

const BucketBar = styled.div`
  width: 30px;
  border-radius: 6px;
  background-color: ${({ score }) => BarColors[score]};
  height: ${({ height }) => height}%;
`;

const BucketGraphWrapper = styled.div`
  display: flex;
  flex-basis: 50%;
  justify-content: center;
  align-items: flex-end;
`;

const BucketGraph = ({ responsesByScore = [] }) => {
  const maxFrequency = Math.max(
    ...responsesByScore.map(({ frequency }) => frequency)
  );

  return (
    <BucketGraphWrapper>
      {responsesByScore.map(({ score, frequency }) => (
        <BucketWrapper key={score}>
          <BucketBar score={score} height={100 * (frequency / maxFrequency)} />
          <BucketLabel>{score}</BucketLabel>
        </BucketWrapper>
      ))}
    </BucketGraphWrapper>
  );
};

BucketGraph.propTypes = {
  responsesByScore: PropTypes.arrayOf(
    PropTypes.shape({ score: PropTypes.number, frequency: PropTypes.number })
  ),
};

export default BucketGraph;
